import { useEffect, useState } from 'react';

// Карточка юрлица из public/legal/company.json.
//
// Импортировать lib/company.js из компонентов нельзя: даже за динамическим import()
// webpack создаёт чанк, и ИНН с расчётным счётом ложатся файлом в установку клиента
// (измерено 04.09.2026). `public/` копируется как есть, и на издании onprem генератор
// эти файлы не создаёт — значит их нет.
//
// Пока карточка не приехала, возвращается null: подвал и блок реквизитов просто не
// рисуются. Для клиентской установки это и есть правильное поведение, а не ошибка.
//
// seedCompanyCard — для шага сборки scripts/prerender.js: там запросов нет, и
// карточку кладут заранее, чтобы в готовом HTML стояли контакты и реквизиты.
// В браузере её никто не зовёт, и первый рендер по-прежнему без карточки.
let seeded = null;

export function seedCompanyCard(card) {
  seeded = card || null;
}

export default function useCompanyCard() {
  const [card, setCard] = useState(seeded);

  useEffect(() => {
    let alive = true;
    fetch('/legal/company.json')
      .then((r) => (r.ok ? r.json() : Promise.reject(new Error(String(r.status)))))
      .then((d) => { if (alive) setCard(d); })
      .catch(() => {});
    return () => { alive = false; };
  }, []);

  return card;
}
